"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCALE = exports.DEFAULT_LOCALE_CODE = exports.DEFAULT_LANGUAGE_CODE = exports.LOCALES = exports.COUNTRIES = exports.DATA_CENTERS = exports.LANGUAGES = exports.Locale = exports.DataCenterCode = exports.CountryCode = exports.LanguageCode = void 0;
var FLAG_ICON_BASE_URL = 'https://cloverstatic.com/content/icons/medium/flags';
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["ENGLISH"] = "en";
    LanguageCode["FRENCH"] = "fr";
    LanguageCode["SPANISH"] = "es";
    LanguageCode["GERMAN"] = "de";
    LanguageCode["DUTCH"] = "nl";
})(LanguageCode = exports.LanguageCode || (exports.LanguageCode = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["UNITED_STATES"] = "US";
    CountryCode["CANADA"] = "CA";
    CountryCode["ARGENTINA"] = "AR";
    CountryCode["UNITED_KINGDOM"] = "GB";
    CountryCode["GERMANY"] = "DE";
    CountryCode["AUSTRIA"] = "AT";
    CountryCode["IRELAND"] = "IE";
    CountryCode["NETHERLANDS"] = "NL";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
var DataCenterCode;
(function (DataCenterCode) {
    DataCenterCode["NORTH_AMERICA"] = "NA";
    DataCenterCode["LATIN_AMERICA"] = "LA";
    DataCenterCode["EUROPE"] = "EU";
})(DataCenterCode = exports.DataCenterCode || (exports.DataCenterCode = {}));
var Locale = /** @class */ (function () {
    function Locale(country, language) {
        this.displayName = (country.displayName[language.code] || country.displayName[exports.DEFAULT_LANGUAGE_CODE]) + " (" + language.displayName + ")";
        this.country = country;
        this.languageCode = language.code;
        this.code = language.code.toLowerCase() + "-" + country.code.toUpperCase();
        this.dataCenter = country.dataCenter;
    }
    return Locale;
}());
exports.Locale = Locale;
exports.LANGUAGES = (_a = {},
    _a[LanguageCode.ENGLISH] = {
        displayName: 'English',
        code: LanguageCode.ENGLISH,
    },
    _a[LanguageCode.FRENCH] = {
        displayName: 'Français',
        code: LanguageCode.FRENCH,
    },
    _a[LanguageCode.SPANISH] = {
        displayName: 'Español',
        code: LanguageCode.SPANISH,
    },
    _a[LanguageCode.GERMAN] = {
        displayName: 'Deutsch',
        code: LanguageCode.GERMAN,
    },
    _a[LanguageCode.DUTCH] = {
        displayName: 'Nederlands',
        code: LanguageCode.DUTCH,
    },
    _a);
exports.DATA_CENTERS = (_b = {},
    _b[DataCenterCode.NORTH_AMERICA] = {
        displayName: 'North America',
        code: DataCenterCode.NORTH_AMERICA,
        prodHost: 'www.clover.com',
        stgHost: 'stg1.dev.clover.com',
        devHost: 'dev1.dev.clover.com',
        gaTrackingCode: 'UA-73329301-1',
    },
    _b[DataCenterCode.LATIN_AMERICA] = {
        displayName: 'Latin America',
        code: DataCenterCode.LATIN_AMERICA,
        prodHost: 'la.clover.com',
        stgHost: 'stg2.dev.clover.com',
        devHost: 'dev7.dev.clover.com',
    },
    _b[DataCenterCode.EUROPE] = {
        displayName: 'Europe',
        code: DataCenterCode.EUROPE,
        prodHost: 'eu.clover.com',
        stgHost: 'stg3.dev.clover.com',
        devHost: 'demo2.dev.clover.com',
        gaTrackingCode: 'UA-67201534-1',
    },
    _b);
exports.COUNTRIES = (_c = {},
    _c[CountryCode.CANADA] = {
        displayName: { en: 'Canada', fr: 'Canada' },
        code: CountryCode.CANADA,
        languages: [exports.LANGUAGES.en, exports.LANGUAGES.fr],
        iconUrl: FLAG_ICON_BASE_URL + "/canada.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.NORTH_AMERICA],
    },
    _c[CountryCode.UNITED_STATES] = {
        displayName: { en: 'United States', es: 'Estados Unidos' },
        code: CountryCode.UNITED_STATES,
        languages: [exports.LANGUAGES.en],
        iconUrl: FLAG_ICON_BASE_URL + "/united-states.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.NORTH_AMERICA],
    },
    _c[CountryCode.ARGENTINA] = {
        displayName: { en: 'Argentina', es: 'Argentina' },
        code: CountryCode.ARGENTINA,
        languages: [exports.LANGUAGES.es],
        iconUrl: FLAG_ICON_BASE_URL + "/argentina.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.LATIN_AMERICA],
    },
    _c[CountryCode.GERMANY] = {
        displayName: { en: 'Germany', de: 'Deutschland' },
        code: CountryCode.GERMANY,
        languages: [exports.LANGUAGES.de],
        iconUrl: FLAG_ICON_BASE_URL + "/germany.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.EUROPE],
    },
    _c[CountryCode.IRELAND] = {
        displayName: { en: 'Ireland' },
        code: CountryCode.IRELAND,
        languages: [exports.LANGUAGES.en],
        iconUrl: FLAG_ICON_BASE_URL + "/ireland.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.EUROPE],
    },
    _c[CountryCode.NETHERLANDS] = {
        displayName: { en: 'Netherlands', nl: 'Nederlands' },
        code: CountryCode.NETHERLANDS,
        languages: [exports.LANGUAGES.nl, exports.LANGUAGES.en],
        iconUrl: FLAG_ICON_BASE_URL + "/netherlands.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.EUROPE],
    },
    _c[CountryCode.UNITED_KINGDOM] = {
        displayName: { en: 'United Kingdom' },
        code: CountryCode.UNITED_KINGDOM,
        languages: [exports.LANGUAGES.en],
        iconUrl: FLAG_ICON_BASE_URL + "/united-kingdom.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.EUROPE],
    },
    _c[CountryCode.AUSTRIA] = {
        displayName: { en: 'Austria', de: 'Österreich' },
        code: CountryCode.AUSTRIA,
        languages: [exports.LANGUAGES.de],
        iconUrl: FLAG_ICON_BASE_URL + "/austria.svg",
        dataCenter: exports.DATA_CENTERS[DataCenterCode.EUROPE],
    },
    _c);
// All supported locales for all data centers
exports.LOCALES = Object.values(exports.COUNTRIES)
    .map(function (c) { return c.languages.map(function (l) { return new Locale(c, l); }); })
    .reduce(function (map, localeArray) {
    var newLocales = localeArray.reduce(function (acc, locale) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[locale.code] = locale, _a)));
    }, {});
    return __assign(__assign({}, map), newLocales);
}, {});
exports.DEFAULT_LANGUAGE_CODE = LanguageCode.ENGLISH;
exports.DEFAULT_LOCALE_CODE = 'en-US';
exports.DEFAULT_LOCALE = exports.LOCALES[exports.DEFAULT_LOCALE_CODE];
